import { render, staticRenderFns } from "./vue2-color-picker.vue?vue&type=template&id=ecb812c6&scoped=true&"
import script from "./vue2-color-picker.vue?vue&type=script&lang=js&"
export * from "./vue2-color-picker.vue?vue&type=script&lang=js&"
import style0 from "./vue2-color-picker.vue?vue&type=style&index=0&id=ecb812c6&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb812c6",
  null
  
)

export default component.exports